import React from "react";
import Icon from "../assets/floating-icon.ico";
export default function NoMoni() {
	const [adView, setAdView] = React.useState(false);

	async function detectAdBlock() {
		const googleAdUrl =
			"https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
		try {
			await fetch(new Request(googleAdUrl)).catch((_) => setAdView(true));
		} catch (e) {
			setAdView(true);
		}
	}

	React.useEffect(() => {
		detectAdBlock();
		console.log(adView);
		// eslint-disable-next-line
	}, []);

	if (process.env.NODE_ENV === "development") {
		return null;
	}
	if (!adView) return null;
	else
		return (
			<div
				style={{ zIndex: "500" }}
				className="w-full h-screen fixed top-0 backdrop-filter grid place-items-center backdrop-blur-xl"
			>
				<RenderErrorCard setAdView={setAdView} />
			</div>
		);
}

function RenderErrorCard({ setAdView }) {
	const handelDisablePopUp = () => {
		setAdView(false);
	};
	return (
		<div className="w-4/5 sm:w-3/4  p-2 sm:p-5 md:p-10 bg-gray-900 h-auto rounded-xl shadow-lg hover:shadow-xl duration-200">
			<p className="font-montserrat font-extrabold text-xl md:text-4xl p-5 text-gray-50">
				Opps.... U•ェ•*U
			</p>
			<hr />
			<p className="font-montserrat font-extrabold text-center text-2xl p-5 text-gray-50">
				AdBlock detected.{" "}
			</p>

			<p className="font-montserrat font-extralight text-center text-base p-5 text-gray-50">
				We have kept the ad's to a minimum, so you can enjoy the site, But we do
				need the support we get from ad's to keep the site up and running.
				<br />
				However, if you are seeing this message, it means that you have AdBlock
				enabled.
				<br />
				<br />
				We are not forcing you to disable AdBlock, you can still access the site
				by clicking the button below.
				<br />
				<br />
				<span className="text-red-500">
					However this pop will be triggered every-time you refresh the page. if
					adblock is left enabled.
				</span>
			</p>
			<hr />
			<br />
			<br />

			<img
				className="m-auto hidden sm:block"
				src={Icon}
				alt="Website blocked"
			/>

			<button onClick={handelDisablePopUp} className="btn m-auto  bg-red-500">
				Enter the Site
			</button>
		</div>
	);
}
